import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeaderNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.23621 13.9999C6.7063 14.4148 7.3238 14.6666 8.00009 14.6666C8.67639 14.6666 9.29389 14.4148 9.76398 13.9999M12.0001 5.33325C12.0001 4.27239 11.5787 3.25497 10.8285 2.50482C10.0784 1.75468 9.06096 1.33325 8.00009 1.33325C6.93923 1.33325 5.92181 1.75468 5.17167 2.50482C4.42152 3.25497 4.00009 4.27239 4.00009 5.33325C4.00009 7.39338 3.48041 8.80389 2.89987 9.73686C2.41018 10.5238 2.16533 10.9173 2.17431 11.0271C2.18425 11.1486 2.21 11.195 2.30794 11.2676C2.3964 11.3333 2.79515 11.3333 3.59266 11.3333H12.4075C13.205 11.3333 13.6038 11.3333 13.6922 11.2676C13.7902 11.195 13.8159 11.1486 13.8259 11.0271C13.8349 10.9173 13.59 10.5238 13.1003 9.73686C12.5198 8.80389 12.0001 7.39338 12.0001 5.33325Z",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.23621 13.9999C6.7063 14.4148 7.3238 14.6666 8.00009 14.6666C8.67639 14.6666 9.29389 14.4148 9.76398 13.9999M12.0001 5.33325C12.0001 4.27239 11.5787 3.25497 10.8285 2.50482C10.0784 1.75468 9.06096 1.33325 8.00009 1.33325C6.93923 1.33325 5.92181 1.75468 5.17167 2.50482C4.42152 3.25497 4.00009 4.27239 4.00009 5.33325C4.00009 7.39338 3.48041 8.80389 2.89987 9.73686C2.41018 10.5238 2.16533 10.9173 2.17431 11.0271C2.18425 11.1486 2.21 11.195 2.30794 11.2676C2.3964 11.3333 2.79515 11.3333 3.59266 11.3333H12.4075C13.205 11.3333 13.6038 11.3333 13.6922 11.2676C13.7902 11.195 13.8159 11.1486 13.8259 11.0271C13.8349 10.9173 13.59 10.5238 13.1003 9.73686C12.5198 8.80389 12.0001 7.39338 12.0001 5.33325Z",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHeaderNotifications;
